import { createAsyncThunk } from "@reduxjs/toolkit";
import { smsCampaignService } from "../../services";

const createMessage = createAsyncThunk(
    'smsCampaign/createMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await smsCampaignService.createMessage(
                payload.companyId,
                payload.campaignId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateMessage = createAsyncThunk(
    'smsCampaign/updateMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await smsCampaignService.updateMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteMessage = createAsyncThunk(
    'smsCampaign/deleteMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await smsCampaignService.deleteMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getMessage = createAsyncThunk(
    'smsCampaign/getMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await smsCampaignService.getMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCampaignEchos = createAsyncThunk(
    'smsCampaign/getCampaignEchos',
    async (payload, ThunkAPI) => {
        try{
            const response = await smsCampaignService.getCampaignEchos(
                payload.companyId,
                payload.campaignId, 
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);


export {
    createMessage,
    updateMessage,
    deleteMessage,
    getMessage,
    getCampaignEchos,
}